"use strict";
/*
 * Use this file to call functions in other files, on document ready, window.resize etc.
 */

var carbucks = carbucks || {};

// Document ready
document.addEventListener("DOMContentLoaded", function() {
  setTimeout(function() {
    svg4everybody(); // Fix SVG spritemap in IE/Edge
  });

  // Components
  carbucks.inView.init();
  carbucks.hero.init();
  carbucks.siteHeader.init();
  carbucks.siteNavigation.init();
  carbucks.mobilenavigation.init();
  carbucks.faq.init();
  carbucks.partners.init();
  carbucks.videoOverlay.init();
  carbucks.examples.init();
  carbucks.pricelist.init();

  var inViewItems = document.querySelectorAll(".in-view-item");
  if (inViewItems) {
    var viewItemsAddClass = (item) => {
      if (!item.classList.contains("visible")) {
        item.classList.add("visible");
      }
    };
    carbucks.inView.init(inViewItems, viewItemsAddClass, -100);
  }
});
